export enum ModalVariantE {
  BURN_CAMPAIGN_NFT = 'BURN_CAMPAIGN_NFT',
  BURN_REWARD_NFT = 'BURN_REWARD_NFT',
  REDEEM_PROGRESS_MODAL = 'REDEEM_CAMPAIGN_PROGRESS_MODAL',
  REWARD_EXPIRED_MODAL = 'REWARD_EXPIRED_MODAL',
}
